import React, { useContext, useState, useEffect } from 'react';
import logo from '../img/logo-1.png';
import logoSlim from '../img/logo-slim.png';
import { A } from 'hookrouter';
import { DataContext } from '../store';
import { getIcon } from './crm/shared/field_inputs/shared/FormatHelpers';
import { useTranslation } from 'react-i18next';
import { NAV_MENU_HOME, NAV_MENU_CRM_OPT, NAV_MENU_EN_OPTION, NAV_MENU_EXL_OPT, NAV_MENU_LOGOUT_OPT, NAV_MENU_LOGS_OPT, NAV_MENU_MY_PROFILE_OPT, NAV_MENU_SV_OPTION } from '../i18n/keyConstants';
import OffCanvas from './OffCanvas.js';

export const NavMenu = () => {
    const { store } = useContext(DataContext);
    const user = store?.user;
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('userLocale'));
    const [langMenuIsExpanded, setLangMenuIsExpanded] = useState(false);
    const [mobileNavIsExpanded, setMobileNavIsExpanded] = useState(false);
    const { t } = useTranslation(['navMenu']);

    useEffect(() => {
        function onResize(e) {
            mobileNavIsExpanded && window.innerWidth >= 992 && setMobileNavIsExpanded(false);
        }

        window.addEventListener('resize', onResize);

        return () => window.removeEventListener('resize', onResize);
    }, [mobileNavIsExpanded]);

    const handleSignout = () => {
        window.localStorage.clear();
        window.location.reload();
    };

    const handleLangSelect = (e, lang) => {
        e.preventDefault();
        setSelectedLanguage(lang);
        localStorage.setItem('userLocale', lang);
        window.location.reload();
    };
    const languages = {
        SV: NAV_MENU_SV_OPTION,
        EN: NAV_MENU_EN_OPTION,
    };

    const inCrm = window.location.pathname.startsWith(`/crm`);
    const inExl = window.location.pathname.startsWith(`/exl`);
    const inLogs = window.location.pathname.startsWith(`/logs`);
    const inProfile = window.location.pathname.startsWith(`/employee/${encodeURIComponent(user.id)}/`);
    const inAlltid = !inCrm && !inExl && !inLogs && !inProfile;

    const toggleNavMenu = () => {
        setMobileNavIsExpanded(v => !v);
    }
 
    return (
        <>
            <nav id='navigation-bar' className='navbar navbar-expand-lg bg-dark-blue p-2'>
                {user && user.id ? (
                    <>
                        <button type='button'
                            className='navbar-toggler collapsed'
                            onClick={toggleNavMenu}
                            aria-expanded='false'
                            aria-label='Toggle navigation'>
                            <span className='icon-bar top-bar'></span>
                            <span className='icon-bar middle-bar'></span>
                            <span className='icon-bar bottom-bar'></span>
                        </button>

                        <span className="nav-item navbar-title d-lg-none">
                            {inAlltid && t(NAV_MENU_HOME)}
                            {inCrm && t(NAV_MENU_CRM_OPT)}
                            {inExl && t(NAV_MENU_EXL_OPT)}
                            {inLogs && t(NAV_MENU_LOGS_OPT)}
                            {inProfile && t(NAV_MENU_MY_PROFILE_OPT)}
                        </span>
                    </>
                ) : null }

                <A href='/' className='navbar-brand'>
                    <img src={logo} alt='consid brand logo' className="d-none d-sm-block" />
                    <img src={logoSlim} alt='consid brand logo' className="d-sm-none" />
                </A>

                {user && user.id ? (
                    <>
                        {/* Desktop */}
                        <div className='collapse navbar-collapse justify-content-end' id='navbarText'>
                            <div className='d-none d-lg-flex navbar-nav space-x-1 pr-3'>
                                <div className={'nav-item' + (inAlltid ? ' active' : '')}>
                                    <A href='/' className='c-white px-3'>
                                        {t(NAV_MENU_HOME)}
                                    </A>
                                </div>
                                {(user.isAdmin || user.isCrmUser) && (
                                    <div className={'nav-item' + (inCrm ? ' active' : '')}>
                                        <A href='/crmDeals' className='c-white px-3'>
                                            {t(NAV_MENU_CRM_OPT)}
                                        </A>
                                    </div>
                                )}
                                {(user.isAdmin || user.isExlAdmin || user.isExlUser) && (
                                    <div className={'nav-item' + (inExl ? ' active' : '')}>
                                        <A href='/exlCourses' className='c-white px-3'>
                                            {t(NAV_MENU_EXL_OPT)}
                                        </A>
                                    </div>
                                )}
                            </div>
                            <ul className='d-none d-lg-flex m-0 pr-3 align-items-center space-x-3'>
                                <li className='nav-item dropdown m-0'>
                                    <button className='btn nav-link text-white avatar' id='navbardrop' data-toggle='dropdown'>
                                        {/*<span className='c-white mr-2'>{user.name}</span>*/}
                                        <img src={user.photo} alt='' />
                                    </button>
                                    <div className='dropdown-menu padding-none'>
                                        <A href={`/employee/${user.id}/info`} className='dropdown-item padding-top-15px padding-bottom-15px'>
                                            {t(NAV_MENU_MY_PROFILE_OPT)}
                                        </A>
                                        {user.isAdmin && (
                                            <A href='/logs' className='dropdown-item padding-top-15px padding-bottom-15px'>
                                                {t(NAV_MENU_LOGS_OPT)}
                                            </A>
                                        )}
                                        <div className='dropdown-divider margin-none'></div>
                                        <A
                                            href='/account/signout'
                                            className='dropdown-item padding-top-15px padding-bottom-15px'
                                            onClick={handleSignout}>
                                            {t(NAV_MENU_LOGOUT_OPT)}
                                        </A>
                                    </div>
                                </li>
                                <li className='collapse navbar-collapse m-0 language-dropdown' id="language-dropdown">
                                    <div className='d-lg-flex align-items-center language-dropdown-menu'>
                                        <button className='btn language-expand nav-link' data-toggle='dropdown' onClick={() => setLangMenuIsExpanded(!langMenuIsExpanded)}>
                                            <div className="language-flag">
                                                {getIcon(selectedLanguage+'-flag')}
                                                <span className='lang-text' style={{ marginLeft: '5px' }}>{selectedLanguage}</span>
                                                <i className="oi p-2 text-center dx-g-bs4-toggle-button oi-chevron-bottom" style={{ height: '1px', width: '5px' }}></i>
                                            </div>
                                        </button>
                                        <li className='nav-item dropdown margin-none'>
                                            <div className='dropdown-menu padding-none'>
                                                {Object.keys(languages).map(lang => (
                                                    <a href='#'
                                                        key={lang}
                                                        className='dropdown-item padding-top-15px padding-bottom-15px'
                                                        onClick={(e) => handleLangSelect(e, lang)}
                                                    >
                                                        {t(languages[lang])}
                                                    </a>
                                                ))}
                                            </div>
                                        </li>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </>
                ) : null}
            </nav>

            <OffCanvas toggle={toggleNavMenu} open={mobileNavIsExpanded}>
                {user && user.id ? (
                    <>
                        <div className="text-center p-4 space-y-3">
                            <div className="avatar avatar-large">
                                <img src={user.photo} alt='' />
                            </div>
                            <div className="text-xl font-bold">
                                {user.name}
                            </div>
                        </div>
                        <ul className="border-y divide-y">
                            <li>
                                <A href='/' className={"d-flex py-3 px-4 text-lg font-bold" + (inAlltid ? ' c-white' : ' c-light-grey')} onClick={toggleNavMenu}>
                                    {t(NAV_MENU_HOME)}
                                </A>
                            </li>
                            {(user.isAdmin || user.isCrmUser) && (
                                <li>
                                    <A href='/crmDeals' className={"d-flex py-3 px-4 text-lg font-bold" + (inCrm ? ' c-white' : ' c-light-grey')} onClick={toggleNavMenu}>
                                        {t(NAV_MENU_CRM_OPT)}
                                    </A>
                                </li>
                            )}
                            {(user.isAdmin || user.isExlAdmin || user.isExlUser) && (
                                <li>
                                    <A href='/exlCourses' className={"d-flex py-3 px-4 text-lg font-bold" + (inExl ? ' c-white' : ' c-light-grey')} onClick={toggleNavMenu}>
                                        {t(NAV_MENU_EXL_OPT)}
                                    </A>
                                </li>
                            )}
                            {user.isAdmin && (
                                <li>
                                    <A href='/logs' className={"d-flex py-3 px-4 text-lg font-bold" + (inLogs ? ' c-white' : ' c-light-grey')} onClick={toggleNavMenu}>
                                        {t(NAV_MENU_LOGS_OPT)}
                                    </A>
                                </li>
                            )}
                            <li>
                                <A href={`/employee/${user.id}/info`} className={"d-flex py-3 px-4 text-lg font-bold" + (inProfile ? ' c-white' : ' c-light-grey')} onClick={toggleNavMenu}>
                                    {t(NAV_MENU_MY_PROFILE_OPT)}
                                </A>
                            </li>
                        </ul>
                        <div className="flex-fill"></div>
                        <ul className="border-t divide-y">
                            <li className="px-4 py-3 space-x-3">
                                {Object.keys(languages).map(lang => (
                                    <button type='button'
                                        key={lang}
                                        className={'language-select-mobile-button' + (selectedLanguage === lang ? ' selected' : '')}
                                        onClick={(e) => handleLangSelect(e, lang)}
                                    >
                                        {getIcon(`${lang}-flag`)}
                                    </button>
                                ))}
                            </li>
                            <li>
                                <A href='/account/signout' className={"d-flex py-3 px-4 text-lg font-bold c-light-grey"} onClick={() => window.location.reload()}>
                                    {t(NAV_MENU_LOGOUT_OPT)}
                                </A>
                            </li>
                        </ul>
                    </>
                ) : null}
            </OffCanvas>
        </>
    );
};
